import { Divider, Space, Typography } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import tw from "twin.macro";
import { COLOR_THEME, ColorThemeTypes } from "./theme";

export interface IBox {
  title: string;
  count: number;
  appealTotal?: number;
  feedbackTotal?: number;
  suggestTotal?: number;
  color: ColorThemeTypes;
  text?: string;
  textAfter?: boolean;
  isGrid?: boolean;
}

const BoxStyle = styled.div<{ bg: string; color: string }>`
  ${tw`h-[150px] rounded-app`}
  background-color: ${({ bg }) => bg};
  color: ${({ color }) => color};

  .ant-typography {
    color: ${({ color }) => color};
  }
`;

export const Box: FC<IBox> = ({
  title,
  color,
  count,
  text,
  isGrid,
  appealTotal,
  feedbackTotal,
  suggestTotal,
  textAfter = true,
}) => {
  const { t } = useTranslation();
  const theme = COLOR_THEME[color];

  return (
    <BoxStyle bg={theme.bg} color={theme.colorText} className="center">
      {!isGrid && (
        <Space direction="vertical" className="center">
          <div>{title}</div>
          <Typography.Title level={3}>
            {count.toLocaleString()}
          </Typography.Title>
          <div hidden={!textAfter}>{text ? text : t("work")}</div>
        </Space>
      )}
      {isGrid && (
        <div className="flex flex-col">
          <div className="flex justify-center mb-4"> {title}</div>
          <div className="flex justify-between items-start gap-4">
            <div className="flex flex-row gap-4">
              <div className="flex flex-col gap-4">
                <div >{t("complaint")}</div>
                <div className="flex justify-center">{appealTotal}</div>
              </div>
              <Divider type="vertical" style={{ height: 100 }} />
            </div>
            <div className="flex flex-row gap-4">
              <div className="flex flex-col gap-4">
                <div >{t("feedback")}</div>
                <div className="flex justify-center">{feedbackTotal}</div>
              </div>
              <Divider type="vertical" style={{ height: 100 }} />
            </div>
            <div className="flex flex-row gap-4">
              <div className="flex flex-col gap-4">
                <div >{t("suggest")}</div>
                <div className="flex justify-center">{suggestTotal}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </BoxStyle>
  );
};
